var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00021 15.1663C4.53355 15.1663 1.72021 12.3463 1.72021 8.88628C1.72021 5.42628 4.53355 2.59961 8.00021 2.59961C8.71355 2.59961 9.40688 2.69961 10.0735 2.90628C10.3402 2.98628 10.4869 3.26628 10.4069 3.53294C10.3269 3.79961 10.0469 3.94628 9.78021 3.86628C9.21355 3.69294 8.61355 3.59961 8.00021 3.59961C5.08688 3.59961 2.72021 5.96628 2.72021 8.87961C2.72021 11.7929 5.08688 14.1596 8.00021 14.1596C10.9135 14.1596 13.2802 11.7929 13.2802 8.87961C13.2802 7.82628 12.9735 6.81294 12.3935 5.94628C12.2402 5.71961 12.3002 5.40628 12.5335 5.25294C12.7602 5.09961 13.0735 5.15961 13.2269 5.39294C13.9202 6.42628 14.2869 7.63294 14.2869 8.88628C14.2802 12.3463 11.4669 15.1663 8.00021 15.1663Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7531 4.04615C10.6131 4.04615 10.4731 3.98615 10.3731 3.87282L8.44647 1.65949C8.26647 1.45282 8.28647 1.13282 8.49314 0.952821C8.69981 0.772821 9.01981 0.792821 9.19981 0.999488L11.1265 3.21282C11.3065 3.41949 11.2865 3.73949 11.0798 3.91949C10.9931 4.00615 10.8731 4.04615 10.7531 4.04615Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50648 5.68745C8.35315 5.68745 8.19982 5.61412 8.09982 5.48078C7.93982 5.26078 7.98648 4.94745 8.20648 4.78078L10.4531 3.14078C10.6731 2.97412 10.9865 3.02745 11.1531 3.24745C11.3198 3.46745 11.2665 3.78078 11.0465 3.94745L8.79982 5.59412C8.71315 5.66078 8.61315 5.68745 8.50648 5.68745Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/rotate-right.2efa8d555b446656cff6c137727ae314.svg";
export { ForwardRef as ReactComponent };